(function () {
  'use strict';
  function boot() {
    var root = document.querySelector('.tb-hero--viewer');
    if (!root || !root.tbHero) return;
    var api = root.tbHero, select = root.querySelector('.tb-map-select');
    var status = root.querySelector('.tb-catalog-status');
    var ca = root.dataset.locale === 'ca', prefix = root.dataset.site || '';
    var count = select.options.length;
    var known = new Set(Array.from(select.options).map(function (o) { return o.value; }));
    function text(a, b) { return ca ? a : b; }
    function record(product) {
      if (!product.published_at || String(product.product_type).toLowerCase() === 'hoodie') return null;
      var images = product.images || [], index = images.findIndex(function (image) {
        var filename = image.src.split('?')[0].split('/').pop().toLowerCase();
        return image.width >= 900 && image.height > 0 && Math.abs(image.width / image.height - 1) > 0.04 &&
          !/(framed|display|mockup|_product|story|interior)/.test(filename);
      });
      if (index < 0) return null;
      var image = images[index], aspect = image.width / image.height;
      var result = {id:product.id,t:product.title,u:prefix+'/products/'+product.handle,a:aspect,w:image.width,h:image.height,img:image.src};
      var details = images.slice(index + 1, index + 7).filter(function (im) {
        return im.height > 0 && Math.abs(im.width / im.height - aspect) < 0.012;
      }).slice(0,4);
      if (details.length === 4) result.q = details.map(function (im) { return [im.src, im.width, im.height]; });
      return result;
    }
    select.addEventListener('change', function () { api.select(select.value); });
    root.addEventListener('trobart:map-change', function (event) { select.value = event.detail.id; });
    async function load() {
      try {
        for (var page = 1; ; page++) {
          var controller = new AbortController();
          var timeout = setTimeout(function () { controller.abort(); }, 20000);
          var response;
          try {
            response = await fetch(root.dataset.catalogue + '?limit=250&page=' + page, {credentials:'same-origin',signal:controller.signal});
            if (!response.ok) throw new Error('Catalogue unavailable');
            var data = await response.json();
          } finally { clearTimeout(timeout); }
          if (!Array.isArray(data.products)) throw new Error('Invalid catalogue');
          var maps = data.products.map(record).filter(Boolean);
          api.addMaps(maps);
          var fragment = document.createDocumentFragment();
          maps.forEach(function (map) {
            var id = String(map.id);
            if (known.has(id)) return;
            known.add(id); count++;
            var option = document.createElement('option');
            option.value = id; option.textContent = map.t; fragment.appendChild(option);
          });
          select.appendChild(fragment);
          status.textContent = count + text(' mapes · carregant el catàleg…', ' mapas · cargando el catálogo…');
          if (data.products.length < 250) break;
        }
        status.textContent = count + text(' mapes disponibles', ' mapas disponibles');
      } catch (error) {
        status.textContent = text('No hem pogut carregar tot el catàleg. Pots explorar els mapes disponibles.', 'No hemos podido cargar todo el catálogo. Puedes explorar los mapas disponibles.');
      }
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !event.target.closest('input,select,textarea')) {
        window.location.assign(root.dataset.return);
      }
    });
    load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
